export const COMET_EXTERNAL_PROTOCOL = 'comet-external:';
export const PERPLEXITY_APP_PROTOCOL = 'perplexity-app:';
// Uses "perplexity-desktop:" instead of "perplexity-app:" because
// "perplexity-app:" is registered by the old Catalyst macOS app.
// Both apps can be installed side-by-side so they need distinct deeplink schemes.
export const PERPLEXITY_DESKTOP_PROTOCOL = 'perplexity-desktop:';
export const PERPLEXITY_DESKTOP_BETA_PROTOCOL = 'perplexity-desktop-beta:';
export const PERPLEXITY_COMPUTER_PROTOCOL = 'perplexity-computer:';
export const PPLX_USER_MENTION_PREFIX = 'pplx://mention/';
//# sourceMappingURL=protocols.js.map